<template>
  <div class="pay-box">
    <img :src="$baseUrl+llll.logo" alt="">
    <span>会员费用支付</span>
    <span>{{payMoney}}元</span>
    <button v-loading="loading" @click="payFun">支付</button>
  </div>
</template>
  
<script>
import "@/utils/rem";
import { getForm } from "@/api/gwxx";
import { jsPay ,commodity} from "@/api/g_login";
export default {
  name: "pay-page",
  data() {
    return {
      llll:'',
      orderNo:this.$route.query.orderNo,
      payCode:'',
      loading:false,
      payMoney:this.$route.query.money,
      type:''
    };
  },
  mounted(){
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('micromessenger') !== -1) {
      const lujing = window.location.href;
      this.payCode = lujing.match(/code=(\S*)&state/)[1];
    }
    getForm().then((res)=>{
      this.llll = JSON.parse(res.data)
    })
  },
  methods: {
   payFun(){
     this.loading = true
     jsPay({orderNo:this.orderNo,code:this.payCode}).then((res)=>{
      console.log("hhhhhhhhh",res);
      if (res.data.type == '续费') {
        this.type = '续费'
      }else{
        this.type = '注册'
      }
       this.loading = false
       if (typeof WeixinJSBridge == "undefined") {
		       if (document.addEventListener) {
		           document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(res.data), false);
		       } else if (document.attachEvent) {
		           document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(res.data));
		           document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(res.data));
		       }
		   } else {
		       this.onBridgeReady(res.data);
		   }
      }).catch(()=>{
        setTimeout(() => {
          window.location.href = this.$baseUrl+'/api/wx/jsPay?orderNo='+this.orderNo
        }, 1500);
      }).finally(()=>{
        this.loading = false
      })
   },
   onBridgeReady(data) {
		  WeixinJSBridge.invoke('getBrandWCPayRequest', {
		      "appId": data.appId,     //公众号ID，由商户传入     
		      "timeStamp": data.timeStamp,     //时间戳，自1970年以来的秒数     
		      "nonceStr": data.nonceStr,      //随机串     
		      "package": data.package,
		      "signType": data.signType,     //微信签名方式：     
		      "paySign": data.paySign//微信签名 
		  },
		  (res)=> {
		      if (res.err_msg == "get_brand_wcpay_request:ok" && this.type == '注册') {
            this.$confirm('注册申请已提交，请耐心等待审核', '提示', {
              confirmButtonText: '确定',
              showCancelButton:false,
              type: 'success'
            }).then(() => {
              window.location.replace(this.$baseUrl+'/#/indexPage')
            })
		      }else{
             this.$confirm('续费成功', '提示', {
              confirmButtonText: '确定',
              showCancelButton:false,
              type: 'success'
            }).then(() => {
              window.location.replace(this.$baseUrl+'/#/indexPage')
            })
          }

		  });
		},
  }
};
</script>
<style>
.pay-box{
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
}
.pay-box img{
  width: 100%;
  height: auto;
}
.pay-box :nth-child(2){
  font-size: 20px;
  margin-top: 50px;
}
.pay-box :nth-child(3){
  font-size: 50px;
  margin-top: 10px;
}
.pay-box :nth-child(4){
  width: 100%;
  height: 45px;
  margin-top: 50px;
  font-size: 20px;
}
</style>